module.exports = __webpack_public_path__ + "static/img/001.18b498d8.png";